// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3AGcG","header":"MergedInvoice_header__2tU_T"};